import { render, staticRenderFns } from "./qfGallery.vue?vue&type=template&id=485f6e41&scoped=true&"
import script from "./qfGallery.vue?vue&type=script&lang=js&"
export * from "./qfGallery.vue?vue&type=script&lang=js&"
import style0 from "./qfGallery.vue?vue&type=style&index=0&id=485f6e41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f6e41",
  null
  
)

export default component.exports